import {
  MDBCarousel,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBCol,
  MDBIcon,
  MDBRow,
} from "mdbreact";
import React, { createRef, useState } from "react";
import TenantSelectElement from "../../elements/tenant-select-element/TenantSelectElement";
import TenantOverviewElement from "../../elements/tenant-overview-element/TenantOverviewElement";
import { Recommend } from "../../../containers/StampCard";
import classes from "./TenantSelectCarousel.module.scss";
import images from "../../../assets/img/app";

type TenantSelectCarouselProps = {
  /** ヘッダアイコン */
  headerIcon: string;
  /** ヘッダテキスト */
  headerText: string;
  /** テナントのリスト */
  tenants: (Recommend & {
    /** テナント選択状態 */
    isChecked?: boolean;
  })[];
  /** 既に1テナント選択済みかどうか*/
  isSelected: boolean;
  /** 「さらに表示」のクリックイベント */
  onMorePanelClick: () => void;
  /** テナントの「詳細を開く」ボタン押下時の処理 */
  onDetailOpenClick: (recommend: Recommend) => void;
  /** テナントの「お店を選ぶ」ボタン押下時の処理 */
  onRecommendSelect: (recommend: Recommend) => void;
};

const TenantSelectCarousel: React.FC<TenantSelectCarouselProps> = (props) => {
  // 一つのページに配置するコンテンツ数
  const contents = 4;
  const tenants = [...props.tenants].concat({
    id: "morePanel",
    name: "さらに表示",
    image: "",
    isChecked: false,
  });
  // const tenants = props.tenants;
  // ページ数
  const pages = Math.ceil(tenants.length / contents);

  // 表示コンテンツをあらかじめページ分割
  const contentsList = Array.from(new Array(pages)).map((_, page) => {
    const begin = contents * page;
    const end = begin + contents;
    const items = tenants.slice(begin, end);
    return items;
  });

  const carouselRef = createRef<MDBCarousel>();
  const firstItemNum = 1;
  const lastItemNum = pages;
  const [activeItem, setActiveItem] = useState(firstItemNum);

  return (
    <div className="my-3">
      <div className={`${classes.categoryHeader} d-table w-100 mt-3`}>
        <div className="d-table-cell text-left">
          <MDBIcon icon={props.headerIcon} />
          <span className="ml-2">{props.headerText}</span>
        </div>
        <div className="d-table-cell text-right">
          {props.isSelected ? (
            <span className={classes.selectedBadge}>
              <MDBIcon icon="check" />
              <span className="ml-1">選択済</span>
            </span>
          ) : null}
        </div>
      </div>
      {props.tenants.length !== 0 && !props.isSelected ? (
        <MDBCarousel
          className="mt-2 mx-1"
          ref={carouselRef}
          activeItem={activeItem}
          length={pages}
          // typescript の型定義不具合で interval に false (＝時間無制限)を設定出来ない模様。
          // 代わりに interval をきわめて長時間(24時間)に設定
          interval={24 * 60 * 60 * 1000} // 単位はms
          showControls={false}
          showIndicators={false}
          mobileGesture={false}
          slide
          multiItem
        >
          <MDBCarouselInner className={`${classes.carouselBody}`}>
            {contentsList.map((items, page) => {
              return (
                <MDBCarouselItem key={page} itemId={(page + 1).toString()}>
                  <MDBRow className={`${classes.carouselItemContainer}`}>
                    {items.map((item) => {
                      return (
                        <MDBCol size="3" key={item.id} className="p-0">
                          {item.id === "morePanel" ? (
                            <div
                              className="mx-2 h-100 d-flex align-items-center"
                              onClick={() => props.onMorePanelClick()}
                            >
                              <img
                                className={`img-fluid mx-auto ${classes.morePanel}`}
                                src={images.more}
                                alt=""
                              />
                            </div>
                          ) : (
                            <div className="mx-2 position-relative">
                              <TenantSelectElement
                                id={item.id}
                                name={item.name}
                                image={item.image}
                                isChecked={item.isChecked}
                                onClick={props.onDetailOpenClick}
                              ></TenantSelectElement>
                              <div className={`${classes.hoveredTenant}`}>
                                <TenantOverviewElement
                                  id={item.id}
                                  name={item.name}
                                  image={item.image}
                                  description={item.description}
                                  onDetailOpenClick={() => {
                                    props.onDetailOpenClick(item);
                                  }}
                                  onStampSelect={() =>
                                    props.onRecommendSelect(item)
                                  }
                                ></TenantOverviewElement>
                              </div>
                            </div>
                          )}
                        </MDBCol>
                      );
                    })}
                  </MDBRow>
                </MDBCarouselItem>
              );
            })}
          </MDBCarouselInner>
          <button
            className={`d-flex align-items-center justify-content-center
              ${classes.pagingButton}
              ${classes.prev}
              ${activeItem === firstItemNum && classes.buttonClear}
            `}
            onClick={() => {
              if (carouselRef.current) {
                const carouselComp: any = carouselRef.current;
                const prevItem = Math.max(activeItem - 1, firstItemNum);
                carouselComp.goToIndex(prevItem);
                setActiveItem(prevItem);
              }
            }}
          >
            <MDBIcon icon="angle-left" />
          </button>
          <button
            className={`d-flex align-items-center justify-content-center
              ${classes.pagingButton}
              ${classes.next}
              ${activeItem === lastItemNum && classes.buttonClear}
            `}
            onClick={() => {
              if (carouselRef.current) {
                const carouselComp: any = carouselRef.current;
                const nextItem = Math.min(activeItem + 1, lastItemNum);
                carouselComp.goToIndex(nextItem);
                setActiveItem(nextItem);
              }
            }}
          >
            <MDBIcon icon="angle-right" />
          </button>
        </MDBCarousel>
      ) : null}
    </div>
  );
};

export default TenantSelectCarousel;
